import React from "react"
import * as styles from './BoxList.module.scss'
import BoxListItem from "./BoxListItem/BoxListItem"


const BoxList = ({list, classes}) => {
    const boxListItems = list.map((item, idx) => {
        return <BoxListItem key={idx} item={item} />
    })
    // const half = Math.ceil(checkListItems.length / 2);    

    // const firstHalf = checkListItems.slice(0, half)
    // const secondHalf = checkListItems.slice(-half)

    return(  
        <section className={`${styles.boxList_wrap}` }>
            {boxListItems}
            {/* <ul className={`${styles.boxList_column}` }>
                {firstHalf}
            </ul>  
            <ul className={`${styles.boxList_column}` }>
                {secondHalf}
            </ul>  */}
        </section>
                   
    )
}

export default BoxList